(function (angular) {
    'use strict';

    angular.module('channels.email')
        /**
         *
         */
        .controller('EmailSettingsCtrl',
            ['$scope', '$rootScope', '$stateParams', 'emailSettings', 'emailSettingsService', 'growlService', '$uibModalInstance',
                function ($scope, $rootScope, $stateParams, emailSettings, emailSettingsService, growlService, $uibModalInstance) {

                    $scope.emailConfigForm = {};

                    $scope.updateData = function () {
                        $scope.emailConfigForm = {
                            defaultFromName: $scope.emailConfig.defaultFromName,
                            defaultMailboxName: $scope.emailConfig.defaultMailboxName.toLowerCase()
                        };
                    };
                    assignEmailSettings(emailSettings);
                    $scope.updateData();


                    // $scope.delete = function () {
                    //     sweetAlertService.confirmationAlert(
                    //         "",
                    //         "Are you sure you want to remove email channel configuration?",
                    //         "Remove Configuration",
                    //         "Cancel",
                    //         function (isConfirmed) {
                    //             if (isConfirmed) {
                    //                 emailSettingsService.deleteEmailSettings($stateParams.pickedApiSpaceId)
                    //                     .then(function () {
                    //                         $scope.editing = false;
                    //                         $scope.emailConfig = {
                    //                             defaultFromName: '',
                    //                             defaultMailboxName: ''
                    //                         };
                    //                         $scope.updateData();
                    //                         growlService.success("Email configuration was deleted");

                    //                     }).catch(function (error) {

                    //                         growlService.danger("Email configuration wasn't deleted due to: " + error.statusText);
                    //                     });
                    //             }
                    //         }
                    //     );

                    // };

                    $scope.cancel = function () {
                        $uibModalInstance.dismiss('cancel');
                    };

                    $scope.update = function () {
                        var updateData = {
                            defaultFromName: $scope.emailConfigForm.defaultFromName,
                            defaultMailboxName: $scope.emailConfigForm.defaultMailboxName.toLowerCase()
                        };
                        emailSettingsService.updateEmailSettings($stateParams.pickedApiSpaceId, updateData)
                            .then(function (config) {
                                $scope.emailConfig = config;
                                $rootScope.$broadcast('Email channel configured');
                                growlService.success("Email configuration was updated!");
                                $uibModalInstance.close('saved');

                            }).catch(function (error) {
                                $scope.updateData();
                                growlService.danger("Email configuration wasn't set due to: " + error.statusText);
                            });

                    };
                    function assignEmailSettings(emailSettings) {
                        if (emailSettings.status && emailSettings.status == 404) {
                            $scope.emailConfig = {
                                defaultFromName: '',
                                defaultMailboxName: ''
                            };

                        } else {
                            $scope.emailConfig = emailSettings;
                        }
                    }

                    // assign to scope for testing
                    $scope.assignEmailSettings = assignEmailSettings;

                }]);

})(window.angular);
